<template>
  <div class="bl-box">
    <div
      class="bl-banner"
      :style="{
        backgroundImage: `url(https://cdn.yxvzb.com/WEB%2Fwx-master%2Fimages%2Fbg_topic${gradientImage +
          1}.png)`
      }"
    >
      <div class="">
        <p>{{ params.categoryName }}</p>
        <p>{{ count }}帖子</p>
      </div>
    </div>

    <div class="hasPadding" @touchmove="preLoad(getPre)">
      <Bingli :list="list"></Bingli>
      <p style="text-align:center;margin-top: 1rem" v-show="!list.length">
        <inline-loading></inline-loading>
        <span
          style="vertical-align:middle;display:inline-block;font-size:14px;"
        >
          &nbsp;&nbsp;加载中
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import Bingli from '@/components/Headline/Bingli.vue';
import { headline } from '@/api/ajax.js';
import { loadMore } from '@/Mixin/loadMore.js';
export default {
  mixins: [loadMore],
  data() {
    return {
      params: {
        pageNo: 1,
        pageSize: 20,
        id: this.$route.params.id,
        categoryName: this.$route.query.categoryName
      },
      list: [],
      loadFlag: true,
      count: 0,
      gradientImage: 0 // 背景
    };
  },
  methods: {
    info() {
      //初始化滑动
      this.courseList = [];
      this.params.pageNo = 1;
      this.loadFlag = true;
    },
    getList(data) {
      if (this.loadFlag) {
        this.loadFlag = false;
        headline.contentList(data).then(res => {
          let resp = res.data.data;
          this.count = resp.total;
          for (var i = 0; i < resp.list.length; i++) {
            this.list.push(resp.list[i]);
          }
          if (resp.list.length < this.params.pageSize) {
            this.loadFlag = false;
            return false;
          }
          this.params.pageNo += 1;
          this.loadFlag = true;
        });
      }
    },
    getPre() {
      this.getList(this.params);
    }
  },
  components: {
    Bingli
  },
  created() {
    this.getPre();
    let count = 0;
    for (let name of this.$route.query.categoryName) {
      count += name.charCodeAt(0);
    }
    let tagColor = count % 7;
    this.gradientImage = tagColor;
  }
};
</script>

<style lang="less" scoped>
.bl-box {
  .bl-banner {
    width: 100%;
    height: 4.08rem /* 306/75 */;
    background-size: cover;
    // background: red;
    display: flex;
    align-items: center;
    // flex-wrap: wrap;
    div {
      width: 100%;
    }
    p {
      color: #fff;
      width: 100%;
      text-align: center;
      line-height: 1;
    }
    p:nth-child(1) {
      font-size: 0.8rem /* 60/75 */;
      margin-bottom: 0.2533rem /* 19/75 */;
    }
    p:nth-child(2) {
      font-size: 0.4rem;
    }
  }
}
</style>
